import AxiosService from './AxiosService'

class AdvancedSettingsRestService {
  static get(): Promise<any> {
    return AxiosService.get('/settings/advanced')
  }

  static getGroup(groupName: string): Promise<any> {
    return AxiosService.get('/settings/advanced/' + groupName)
  }

  static updateGroup(groupName: string, settings: any[]): Promise<any> {
    return AxiosService.put(`/settings/advanced/${groupName}`, settings)
  }

  static updateSetting(setting: any): Promise<any> {
    return AxiosService.put(`/settings/advanced/${setting.groupName}/${setting.name}`, setting)
  }
}

export default AdvancedSettingsRestService
